module.exports = __webpack_public_path__ + "static/media/ic_noti_new.9a021885.svg";